import Row from '@components/row'
import Typography from '@components/typography'
import { FC } from 'react'
import { StyleLink } from './style'
interface AuthFooterProps {
  title: string
  to?: string
  linkTitle?: string
}
const AuthFooter: FC<AuthFooterProps> = ({ title, to, linkTitle }) => {
  return (
    <Row
      justifyContent="center"
      colGap={10}
      alignItems="center"
      styleRow="margin-bottom:10px;"
    >
      <Typography content={title} tc="text100" size={14} weight={300} />
      <StyleLink
        to={to}
        state={{
          purpose: linkTitle == 'Signup Now' ? 'Register' : '',
        }}
      >
        {linkTitle}
      </StyleLink>
    </Row>
  )
}

export default AuthFooter
